import i18n from '@/lang/i18n'
import { ConfigurationRateGridConceptsDatasource } from '@/modules/configurationModule/detail/local-accounting/billable/rates/datasource/configuration-rate-grid-concepts-datasource'
import { BillableRateBillableConceptResponse } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/billable-rate-billable-concept/billable-rate-billable-concept.dto'
import { billableRateBillableConceptService } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/billable-rate-billable-concept/billable-rate-billable-concept.service'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { store } from '@/store/store'

export const localAccountingRateConceptsColumnsDef =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.concept'),
            field: 'concept.name',
            minWidth: 190,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: `${i18n.tc('configuration.grid.code')} (${i18n.tc('configuration.sections.concept')})`,
            field: 'concept.code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: `${i18n.tc('configuration.grid.group')} (${i18n.tc('configuration.sections.concept')})`,
            field: 'concept.group.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.rate.reference'),
            field: 'referenceCode',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.rate.alias'),
            field: 'alias',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.rate.realValue'),
            field: 'referenceValue',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.rate.accountantValue'),
            field: 'billableValue',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.copayment'),
            field: 'hasCopayments',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.rate.bonusValue'),
            field: 'copaymentValue',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.modal.rate.authorizationRequired'),
            field: 'requiresAuthorization',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationLocalAccountingRateConceptsGridState<R = BillableRateBillableConceptResponse> extends CrudModelBase<R, ConfigurationRateGridConceptsDatasource<R>> {
    service: typeof billableRateBillableConceptService
    laboratoryId: number
}
export const initialLocalAccountingRateConceptsGridState =
    (rateId: number): ConfigurationLocalAccountingRateConceptsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.accounting.rates',
        columnsDef: localAccountingRateConceptsColumnsDef(),
        datasource: new ConfigurationRateGridConceptsDatasource(billableRateBillableConceptService, store.getters.labId, rateId),
        service: billableRateBillableConceptService,
        laboratoryId: store.getters.labId
    })
